import { useState } from 'react';
// redux
import { useSelector } from 'react-redux';
import { RootState } from '../../../store';
// mui components
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Tooltip from '@mui/material/Tooltip';
// mui icons
import PeopleIcon from '@mui/icons-material/People';

const ITEM_HEIGHT = 48;

const Usuarios = () => {

  const { usuarios, usuario } = useSelector((state: RootState) => state.usuario);

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div className='mx-3'>
      <Tooltip title="Conectados">
        <IconButton
          aria-label="more"
          id="long-button"
          aria-controls={open ? 'long-menu' : undefined}
          aria-expanded={open ? 'true' : undefined}
          aria-haspopup="true"
          onClick={handleClick}
        >
          <PeopleIcon color='success'/>
          <span 
            style={{
              position: 'absolute', 
              right: -4, 
              bottom: -4, 
              fontSize: '0.5em',
              padding: 2,
              zIndex: -100
            }}
          >
            {usuarios.length}
          </span>
        </IconButton>
      </Tooltip>
      <Menu
        id="long-menu"
        MenuListProps={{
          'aria-labelledby': 'long-button',
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        PaperProps={{
          style: {
            maxHeight: ITEM_HEIGHT * 4.5,
          },
        }}
      >
        <MenuItem
          onClick={handleClose}
        >
          Usuarios conectados
        </MenuItem>

        <MenuItem
          onClick={handleClose}
        >
          <i className="fa fa-circle" aria-hidden="true" style={{color: 'green'}}></i>
          <span className='mx-2'>{usuario.nombre} {usuario.apellido}</span>
        </MenuItem>

        {
          usuarios.filter(item => usuario.uid !== item.uid).map(item => {
            const { uid, nombre, apellido } = item
            return (
              <MenuItem
               key={uid} 
               onClick={handleClose}
              >
                <i className="fa fa-circle" aria-hidden="true" style={{color: 'green'}}></i>
                <span className='mx-2'>{nombre} {apellido}</span>
              </MenuItem>
            )
          })
        }
      </Menu>
    </div>
  )
}

export default Usuarios;